export const API_ENDPOINTS = {
    ASSETCAPTURE: {
      FETCH: '/assetcapture/fetch',
      GET: '/assetcapture/get',
      CREATE: '/assetcapture/create',
      UPDATE: '/assetcapture/update',
      DELETE: '/assetcapture/delete',
      CAPTURE: '/assetcapture/capture',
      VERIFY: '/assetcapture/verify',
      VERIFYLOCATION:'/assetcapture/verifylocation', 
      INTEGRATE: '/assetcapture/integrate',
      GETCONFIGURATION: '/assetcapture/getconfiguration',
      GETCONFIGURATIONS: '/assetcapture/getconfigurations',
      GETCONFIGURATIONSVIEW: '/assetcapture/getconfigurationsview',
      GETASSETSOURCEID: '/assetcapture/getassetsourceid',
      CREATECONFIGURATION: '/assetcapture/createconfiguration',
      UPDATECONFIGURATION: '/assetcapture/updateconfiguration',
      DELETECONFIGURATION: '/assetcapture/deleteconfiguration',
      DELETECONFIGURATIONSTAG: '/assetcapture/deleteconfigurationstag',
      DELETESTAGDATA: '/assetcapture/deletestag',
      //FINISH: '/assetcapture/finish',
      STAGEFETCH: '/assetview/stagefetch',
      STAGEFETCHSEARCH: '/assetview/stagefetchsearch',
      SEARCH: '/assetcapture/search',
      
      CREATEFILESOURCE: '/assetcapture/createfilesource',
      UPDATEFILESOURCE: '/assetcapture/updatefilesource',
      UPLOADFILESOURCE: '/assetcapture/uploadfilesource',

      //combined
      TESTASSETSOURCECONNECTION: '/assetcapture/testconnection',
      DELETE_ASSETSOURCE: '/assetcapture/deleteassetsource',

      //System Asset Source endpoints
      
      IMPORT_SYSTEM_ASSETS_DURING_SETUP: '/assetcapture/importduringsetup',
      READ_SYSTEM_ASSETS_FROM_STAGING_TABLE: '/assetcapture/readfromstagingtable',
      COMPLETE_SYSTEM_ASSET_SETUP: '/assetcapture/completesystemassetsetup',
      FETCH_SYSTEM_ASSET_SOURCE_DETAILS: '/assetcapture/fetchsystemassetsourcedetails',
      UPDATE_SYSTEM_ASSET_SOURCE_DETAILS: '/assetcapture/updatesystemassetsourcedetails',
      FETCH_SYSTEM_ASSET_SOURCE_CONNECTION_DETAILS: '/assetcapture/fetchsystemassetsourceconnectiondetails',
      UPDATE_SYSTEM_ASSET_SOURCE_CONNECTION_DETAILS: '/assetcapture/updatesystemassetsourceconnectiondetails',
      FETCH_SYSTEM_ASSETS_BY_ASSET_SOURCE_ID: '/assetcapture/fetchsystemassetsbyassetsourceid',
      SEARCH_SYSTEM_ASSETS_BY_ASSET_SOURCE_ID: '/assetcapture/searchsystemassetsbyassetsourceid',
      COMPLETE_SYSTEM_ASSET_SETUP_USING_FILE: '/assetcapture/completesystemassetsetupfileusingfile',
      IMPORT_SYSTEM_ASSETS_FROM_FILE_DURING_SETUP: '/assetcapture/importsystemassetsfromfileduringsetup',
      GET_SYSTEM_ASSET_SETUP_USING_FILE: '/assetcapture/getsystemassetsetupfileusingfile',
      UPDATE_SYSTEM_ASSET_SETUP_USING_FILE: '/assetcapture/updatesystemassetsetupfileusingfile',
      CREATE_MANUAL_SYSTEM_ASSET: '/assetcapture/createmanualsystemasset',
      UPDATE_MANUAL_SYSTEM_ASSET: '/assetcapture/updatemanualsystemasset',
      DELETE_MANUAL_SYSTEM_ASSET: '/assetcapture/deletemanualsystemasset',
      GET_MANUAL_SYSTEM_ASSET: '/assetcapture/getmanualsystemasset',
      IMPORT_SYSTEM_ASSETS_BY_ASSET_SOURCE_ID: '/assetcapture/importsystemassetsbyassetsourceid',
      FETCH_SYSTEM_ASSET_SOURCES: '/assetcapture/fetchsystemassetsources',
      IMPORT_SYSTEM_ASSETS_FROM_FILE: '/assetcapture/importsystemassetsfromfile',
      FETCH_SYSTEM_ASSETS_FROM_FILE:'/assetcapture/fetchsystemassetsfromfile',

      ////Data Asset Source endpoints

      IMPORT_DATA_ASSETS_DURING_SETUP: '/assetcapture/importdataassetsduringsetup',
      READ_DATA_ASSETS_FROM_STAGING_TABLE: '/assetcapture/readdataassetsfromstagingtable',
      COMPLETE_DATA_ASSET_SETUP: '/assetcapture/completedataassetsetup',
      FETCH_DATA_ASSET_SOURCE_DETAILS: '/assetcapture/fetchdataassetsourcedetails',
      UPDATE_DATA_ASSET_SOURCE_DETAILS: '/assetcapture/updatedataassetsourcedetails',
      FETCH_DATA_ASSET_SOURCE_CONNECTION_DETAILS: '/assetcapture/fetchdataassetsourceconnectiondetails',
      UPDATE_DATA_ASSET_SOURCE_CONNECTION_DETAILS: '/assetcapture/updatedataassetsourceconnectiondetails',
      FETCH_DATA_ASSETS_BY_ASSET_SOURCE_ID: '/assetcapture/fetchdataassetsbyassetsourceid',
      SEARCH_DATA_ASSETS_BY_ASSET_SOURCE_ID: '/assetcapture/searchdataassetsbyassetsourceid',
      COMPLETE_DATA_ASSET_SETUP_USING_FILE: '/assetcapture/completedataassetsetupfileusingfile',
      IMPORT_DATA_ASSETS_FROM_FILE_DURING_SETUP: '/assetcapture/importdataassetsfromfileduringsetup',
      GET_DATA_ASSET_SETUP_USING_FILE: '/assetcapture/getdataassetsetupfileusingfile',
      UPDATE_DATA_ASSET_SETUP_USING_FILE: '/assetcapture/updatedataassetsetupfileusingfile',
      CREATE_MANUAL_DATA_ASSET: '/assetcapture/createmanualdataasset',
      UPDATE_MANUAL_DATA_ASSET: '/assetcapture/updatemanualdataasset',
      DELETE_MANUAL_DATA_ASSET: '/assetcapture/deletemanualdataasset',
      GET_MANUAL_DATA_ASSET: '/assetcapture/getmanualdataasset',
      IMPORT_DATA_ASSETS_BY_ASSET_SOURCE_ID: '/assetcapture/importdataassetsbyassetsourceid',
      FETCH_DATA_ASSET_SOURCES: '/assetcapture/fetchdataassetsources',
      IMPORT_DATA_ASSETS_FROM_FILE: '/assetcapture/importdataassetsfromfile',
      FETCH_DATA_ASSETS_FROM_FILE:'/assetcapture/fetchdataassetsfromfile',


      //Remaining searches
      FETCH_SYSTEM_ASSET_SOURCES_SEARCH:'/assetcapture/fetchsystemassetsourcessearch',
      FETCH_DATA_ASSET_SOURCES_SEARCH:'/assetcapture/fetchdataassetsourcessearch'
    },
    ASSETVIEW: {
        FETCH: '/assetview/fetch',
        VERIFY: '/assetview/verify',
        FETCHVERIFICATION: '/assetview/verifyview',
        FETCHVERIFICATIONSEARCH: '/assetview/verifyviewsearch',
        SEARCH: '/assetview/search',

        //System and data asset view new flow
        FETCH_SYSTEM_ASSETS_VIEW: '/assetview/fetchsystemassetsview',
        FETCH_SYSTEM_ASSETS_VIEW_SEARCH: '/assetview/fetchsystemassetsviewsearch',
        FETCH_DATA_ASSETS_VIEW: '/assetview/fetchdataassetsview',
        FETCH_DATA_ASSETS_VIEW_SEARCH: '/assetview/fetchdataassetsviewsearch',
        VERIFY_SYSTEM_ASSETS: '/assetview/verifysystemassets',
        FETCH_SYSTEM_ASSETS_VERIFICATION_VIEW: '/assetview/fetchsystemassetsverificationview',
        FETCH_SYSTEM_ASSETS_VERIFICATION_VIEW_SEARCH: '/assetview/fetchsystemassetsverificationviewsearch'
      },

      DATAASSETCONFIGURATION:{
        FETCH_DATA_ASSET_CONFIGURATIONS: '/dataassetconfiguration/fetchdataassetconfiguration',
        FETCH_DATA_ASSET_CONFIGURATIONS_SEARCH:'/dataassetconfiguration/fetchdataassetconfigurationsearch',
        CONFIGURE_DATA_ASSET_FOR_CONFIGURED_STATUS:'/dataassetconfiguration/configuredataassetforconfiguredstatus',
        CONFIGURE_DATA_ASSET_FOR_NOT_CONFIGURED_STATUS:'/dataassetconfiguration/configuredataassetfornotconfiguredstatus',
        FETCH_DATA_ASSET_CONFIGURATION_BY_ID:  '/dataassetconfiguration/fetchdataassetconfigurationbyid',

        FETCH_CONFIGURED_DROPDOWNS_REGIME:  '/dataassetconfiguration/fetchconfigureddropdownsregime',
        CREATE_CONFIGURED_DROPDOWNS_REGIME: '/dataassetconfiguration/createconfigureddropdownsregime',
        FETCH_CONFIGURED_DROPDOWNS_DATA_CLASSIFICATION: '/dataassetconfiguration/fetchconfigureddropdownsdataclassification',
        CREATE_CONFIGURED_DROPDOWNS_DATA_CLASSIFICATION: '/dataassetconfiguration/createconfigureddropdownsdataclassification',
        FETCH_CONFIGURED_DROPDOWNS_DATA_ASSET_TYPE: '/dataassetconfiguration/fetchconfigureddropdownsdataassettype',
        CREATE_CONFIGURED_DROPDOWNS_DATA_ASSET_TYPE: '/dataassetconfiguration/createconfigureddropdownsdataassettype',
        FETCH_CONFIGURED_DROPDOWNS_ASSET_RISK_LEVEL: '/dataassetconfiguration/fetchconfigureddropdownsassetrisklevel',
        CREATE_CONFIGURED_DROPDOWNS_ASSET_RISK_LEVEL: '/dataassetconfiguration/createconfigureddropdownsassetrisklevel',
      },

      ASSET: {
        CREATE: '/assetview/asset/create',
        UPDATE: '/assetview/asset/update',
        DELETE: '/assetview/asset/delete',
        GET: '/assetview/asset/get',
        UPLOAD: '/assetview/asset/upload',
      },

    REPORTS: {
        FETCH: '/assetmanagement/getreports'
    },
    DASHBOARD: {
        FETCH: '/assetmanagement/getdashboarddata',
        FETCHCHARTDATA: '/assetmanagement/getdashboardchartdata'
    }
  };
  